/**
 * This file imports all icons that are required for the project.
 * Note that this is still a subset of all the possible icons within the @autosync/atx-activix-icons package.
 * If you need to add more icons, you can do so by adding the icon to the @autosync/atx-activix-icons package
 * and then importing it here.
 *
 * Remember to define the name for each icon in the iconsMap object below.
 * For the actual usage of the icons, see the @/plugins/svg-icons.ts file.
 */
/* eslint-disable */
import icon_bold_add from '@autosync/atx-activix-icons/bold/add.js';
import icon_bold_alert_circle from '@autosync/atx-activix-icons/bold/alert-circle.js';
import icon_bold_alert_triangle from '@autosync/atx-activix-icons/bold/alert-triangle.js';
import icon_bold_align_left from '@autosync/atx-activix-icons/bold/align-left.js';
import icon_bold_analytics_bars_horizontal from '@autosync/atx-activix-icons/bold/analytics-bars-horizontal.js';
import icon_bold_arrow_button_right_2 from '@autosync/atx-activix-icons/bold/arrow-button-right-2.js';
import icon_bold_arrow_double_right_1 from '@autosync/atx-activix-icons/bold/arrow-double-right-1.js';
import icon_bold_arrow_down from '@autosync/atx-activix-icons/bold/arrow-down.js';
import icon_bold_arrow_down_1 from '@autosync/atx-activix-icons/bold/arrow-down-1.js';
import icon_bold_arrow_up from '@autosync/atx-activix-icons/bold/arrow-up.js';
import icon_bold_arrow_up_1 from '@autosync/atx-activix-icons/bold/arrow-up-1.js';
import icon_bold_arrow_thick_circle_down_1 from '@autosync/atx-activix-icons/bold/arrow-thick-circle-down-1.js';
import icon_bold_arrow_thick_circle_up_1 from '@autosync/atx-activix-icons/bold/arrow-thick-circle-up-1.js';
import icon_bold_arrow_thick_left from '@autosync/atx-activix-icons/bold/arrow-thick-left.js';
import icon_bold_arrow_thick_right from '@autosync/atx-activix-icons/bold/arrow-thick-right.js';
import icon_bold_arrow_thick_circle_bottom_left_corner from '@autosync/atx-activix-icons/bold/arrow-thick-circle-bottom-left-corner.js';
import icon_bold_arrow_thick_circle_bottom_right_corner from '@autosync/atx-activix-icons/bold/arrow-thick-circle-bottom-right-corner.js';
import icon_bold_autotrader_badge from '@autosync/atx-activix-icons/bold/autotrader-badge.js';
import icon_bold_button_stop_1 from '@autosync/atx-activix-icons/bold/button-stop-1.js';
import icon_bold_car_retro_1 from '@autosync/atx-activix-icons/bold/car-retro-1.js';
import icon_bold_check_1 from '@autosync/atx-activix-icons/bold/check-1.js';
import icon_bold_check_2 from '@autosync/atx-activix-icons/bold/check-2.js';
import icon_bold_check_circle_1 from '@autosync/atx-activix-icons/bold/check-circle-1.js';
import icon_bold_check_double_1 from '@autosync/atx-activix-icons/bold/check-double-1.js';
import icon_bold_close from '@autosync/atx-activix-icons/bold/close.js';
import icon_bold_controls_pause from '@autosync/atx-activix-icons/bold/controls-pause.js';
import icon_bold_arrow_button_circle_right from '@autosync/atx-activix-icons/bold/arrow-button-circle-right.js';
import icon_bold_currency_dollar from '@autosync/atx-activix-icons/bold/currency-dollar.js';
import icon_bold_delete_2 from '@autosync/atx-activix-icons/bold/delete-2.js';
import icon_bold_dial_finger from '@autosync/atx-activix-icons/bold/dial-finger.js';
import icon_bold_dislike_1 from '@autosync/atx-activix-icons/bold/dislike-1.js';
import icon_bold_email_action_reply from '@autosync/atx-activix-icons/bold/email-action-reply.js';
import icon_bold_email_action_unread from '@autosync/atx-activix-icons/bold/email-action-unread.js';
import icon_bold_filter_2 from '@autosync/atx-activix-icons/bold/filter-2.js';
import icon_bold_layout_module from '@autosync/atx-activix-icons/bold/layout-module.js';
import icon_bold_like_1 from '@autosync/atx-activix-icons/bold/like-1.js';
import icon_bold_megaphone_1 from '@autosync/atx-activix-icons/bold/megaphone-1.js';
import icon_bold_messages_bubble_typing_1 from '@autosync/atx-activix-icons/bold/messages-bubble-typing-1.js';
import icon_bold_microphone from '@autosync/atx-activix-icons/bold/microphone.js';
import icon_bold_multiple_neutral_2 from '@autosync/atx-activix-icons/bold/multiple-neutral-2.js';
import icon_bold_navigation_menu_horizontal from '@autosync/atx-activix-icons/bold/navigation-menu-horizontal.js';
import icon_bold_navigation_menu_horizontal_1 from '@autosync/atx-activix-icons/bold/navigation-menu-horizontal-1.js';
import icon_bold_navigation_menu_horizontal_2 from '@autosync/atx-activix-icons/bold/navigation-menu-horizontal-2.js';
import icon_bold_navigation_menu_vertical from '@autosync/atx-activix-icons/bold/navigation-menu-vertical.js';
import icon_bold_phone from '@autosync/atx-activix-icons/bold/phone.js';
import icon_bold_pencil_circle from '@autosync/atx-activix-icons/bold/pencil-circle.js';
import icon_bold_pin from '@autosync/atx-activix-icons/bold/pin.js';
import icon_bold_question_circle from '@autosync/atx-activix-icons/bold/question-circle.js';
import icon_bold_rating_star from '@autosync/atx-activix-icons/bold/rating-star.js';
import icon_bold_rating_star_1 from '@autosync/atx-activix-icons/bold/rating-star-1.js';
import icon_bold_remove_circle from '@autosync/atx-activix-icons/bold/remove-circle.js';
import icon_bold_remove from '@autosync/atx-activix-icons/bold/remove.js';
import icon_bold_remove_square from '@autosync/atx-activix-icons/bold/remove-square.js';
import icon_bold_scooter_sport from '@autosync/atx-activix-icons/bold/scooter-sport.js';
import icon_bold_sign_badge_circle from '@autosync/atx-activix-icons/bold/sign-badge-circle.js';
import icon_bold_single_man from '@autosync/atx-activix-icons/bold/single-man.js';
import icon_bold_social_media_facebook_1 from '@autosync/atx-activix-icons/bold/social-media-facebook-1.js';
import icon_bold_subtract_circle from '@autosync/atx-activix-icons/bold/subtract-circle.js';
import icon_bold_subtract_circle_bold from '@autosync/atx-activix-icons/bold/subtract-circle-bold.js';
import icon_bold_subtract from '@autosync/atx-activix-icons/bold/subtract.js';
import icon_bold_synchronize_arrow_1 from '@autosync/atx-activix-icons/bold/synchronize-arrow-1.js';
import icon_bold_synchronize_arrows_triangle from '@autosync/atx-activix-icons/bold/synchronize-arrows-triangle.js';
import icon_bold_time_clock_file_sync from '@autosync/atx-activix-icons/bold/time-clock-file-sync.js';
import icon_bold_tools_wench_screwdriver from '@autosync/atx-activix-icons/bold/tools-wench-screwdriver.js';
import icon_bold_view_1 from '@autosync/atx-activix-icons/bold/view-1.js';
import icon_bold_view_off from '@autosync/atx-activix-icons/bold/view-off.js';
import icon_bold_information_desk_customer from '@autosync/atx-activix-icons/bold/information-desk-customer.js';
import icon_light_award_ribbon_star_3 from '@autosync/atx-activix-icons/light/award-ribbon-star-3.js';
import icon_light_barcode_scan from '@autosync/atx-activix-icons/light/barcode-scan.js';
import icon_light_car_retro_1 from '@autosync/atx-activix-icons/light/car-retro-1.js';
import icon_light_email_action_unread from '@autosync/atx-activix-icons/light/email-action-unread.js';
import icon_light_send_email_monitor from '@autosync/atx-activix-icons/light/send-email-monitor.js';
import icon_light_gauge_dashboard from '@autosync/atx-activix-icons/light/gauge-dashboard.js';
import icon_light_performance_increase_mail from '@autosync/atx-activix-icons/light/performance-increase-mail.js';
import icon_light_pin from '@autosync/atx-activix-icons/light/pin.js';
import icon_light_scooter_sport from '@autosync/atx-activix-icons/light/scooter-sport.js';
import icon_light_trophy from '@autosync/atx-activix-icons/light/trophy.js';
import icon_regular_accessories_tie from '@autosync/atx-activix-icons/regular/accessories-tie.js';
import icon_regular_analytics_graph_bar from '@autosync/atx-activix-icons/regular/analytics-graph-bar.js';
import icon_regular_accounting_bill_stack_1 from '@autosync/atx-activix-icons/regular/accounting-bill-stack-1.js';
import icon_regular_accounting_calculator from '@autosync/atx-activix-icons/regular/accounting-calculator.js';
import icon_regular_accounting_document from '@autosync/atx-activix-icons/regular/accounting-document.js';
import icon_regular_accounting_invoice from '@autosync/atx-activix-icons/regular/accounting-invoice.js';
import icon_regular_add from '@autosync/atx-activix-icons/regular/add.js';
import icon_regular_alarm_bell from '@autosync/atx-activix-icons/regular/alarm-bell.js';
import icon_regular_alarm_bell_ring from '@autosync/atx-activix-icons/regular/alarm-bell-ring.js';
import icon_regular_alarm_bell_sleep from '@autosync/atx-activix-icons/regular/alarm-bell-sleep.js';
import icon_regular_alert_circle from '@autosync/atx-activix-icons/regular/alert-circle.js';
import icon_regular_alert_diamond from '@autosync/atx-activix-icons/regular/alert-diamond.js';
import icon_regular_alert_triangle from '@autosync/atx-activix-icons/regular/alert-triangle.js';
import icon_regular_align_left from '@autosync/atx-activix-icons/regular/align-left.js';
import icon_regular_angle_brackets from '@autosync/atx-activix-icons/regular/angle-brackets.js';
import icon_regular_answer_machine_paper from '@autosync/atx-activix-icons/regular/answer-machine-paper.js';
import icon_regular_archive_folder from '@autosync/atx-activix-icons/regular/archive-folder.js';
import icon_regular_arrow_button_left_1 from '@autosync/atx-activix-icons/regular/arrow-button-left-1.js';
import icon_regular_arrow_button_right_1 from '@autosync/atx-activix-icons/regular/arrow-button-right-1.js';
import icon_regular_arrow_circle_left from '@autosync/atx-activix-icons/regular/arrow-circle-left.js';
import icon_regular_arrow_circle_right from '@autosync/atx-activix-icons/regular/arrow-circle-right.js';
import icon_regular_arrow_corner_right from '@autosync/atx-activix-icons/regular/arrow-corner-right.js';
import icon_regular_arrow_double_right from '@autosync/atx-activix-icons/regular/arrow-double-right.js';
import icon_regular_arrow_down from '@autosync/atx-activix-icons/regular/arrow-down.js';
import icon_regular_arrow_down_1 from '@autosync/atx-activix-icons/regular/arrow-down-1.js';
import icon_regular_arrow_left_1 from '@autosync/atx-activix-icons/regular/arrow-left-1.js';
import icon_regular_arrow_right_1 from '@autosync/atx-activix-icons/regular/arrow-right-1.js';
import icon_regular_arrow_right from '@autosync/atx-activix-icons/regular/arrow-right.js';
import icon_regular_arrow_thick_up from '@autosync/atx-activix-icons/regular/arrow-thick-up.js';
import icon_regular_arrow_up from '@autosync/atx-activix-icons/regular/arrow-up.js';
import icon_regular_arrow_up_1 from '@autosync/atx-activix-icons/regular/arrow-up-1.js';
import icon_regular_attachment from '@autosync/atx-activix-icons/regular/attachment.js';
import icon_regular_audio_file from '@autosync/atx-activix-icons/regular/audio-file.js';
import icon_regular_award_ribbon_star_3 from '@autosync/atx-activix-icons/regular/award-ribbon-star-3.js';
import icon_regular_award_trophy_star_1 from '@autosync/atx-activix-icons/regular/award-trophy-star-1.js';
import icon_regular_baggage from '@autosync/atx-activix-icons/regular/baggage.js';
import icon_regular_bin_paper from '@autosync/atx-activix-icons/regular/bin-paper.js';
import icon_regular_book_open_2 from '@autosync/atx-activix-icons/regular/book-open-2.js';
import icon_regular_bookmarks from '@autosync/atx-activix-icons/regular/bookmarks.js';
import icon_regular_briefcase from '@autosync/atx-activix-icons/regular/briefcase.js';
import icon_regular_business_deal_handshake from '@autosync/atx-activix-icons/regular/business-deal-handshake.js';
import icon_regular_button_refresh_arrows from '@autosync/atx-activix-icons/regular/button-refresh-arrows.js';
import icon_regular_button_refresh_one from '@autosync/atx-activix-icons/regular/button-refresh-one.js';
import icon_regular_button_shuffle from '@autosync/atx-activix-icons/regular/button-shuffle.js';
import icon_regular_calendar_3 from '@autosync/atx-activix-icons/regular/calendar-3.js';
import icon_regular_calendar_add from '@autosync/atx-activix-icons/regular/calendar-add.js';
import icon_regular_calendar_check from '@autosync/atx-activix-icons/regular/calendar-check.js';
import icon_regular_calendar_clock from '@autosync/atx-activix-icons/regular/calendar-clock.js';
import icon_regular_calendar_favorite_heart from '@autosync/atx-activix-icons/regular/calendar-favorite-heart.js';
import icon_regular_calendar_favorite from '@autosync/atx-activix-icons/regular/calendar-favorite.js';
import icon_regular_calendar_search from '@autosync/atx-activix-icons/regular/calendar-search.js';
import icon_regular_calendar_setting from '@autosync/atx-activix-icons/regular/calendar-setting.js';
import icon_regular_calendar_sync from '@autosync/atx-activix-icons/regular/calendar-sync.js';
import icon_regular_calendar from '@autosync/atx-activix-icons/regular/calendar.js';
import icon_regular_car_1 from '@autosync/atx-activix-icons/regular/car-1.js';
import icon_regular_car_actions_disable_1 from '@autosync/atx-activix-icons/regular/car-actions-disable-1.js';
import icon_regular_car_actions_search_1 from '@autosync/atx-activix-icons/regular/car-actions-search-1.js';
import icon_regular_car_actions_shield from '@autosync/atx-activix-icons/regular/car-actions-shield.js';
import icon_regular_car_parking_home from '@autosync/atx-activix-icons/regular/car-parking-home.js';
import icon_regular_car_repair_fluid from '@autosync/atx-activix-icons/regular/car-repair-fluid.js';
import icon_regular_car_retro_2 from '@autosync/atx-activix-icons/regular/car-retro-2.js';
import icon_regular_cash_briefcase from '@autosync/atx-activix-icons/regular/cash-briefcase.js';
import icon_regular_cash_payment_bag from '@autosync/atx-activix-icons/regular/cash-payment-bag.js';
import icon_regular_cash_payment_sign_2 from '@autosync/atx-activix-icons/regular/cash-payment-sign-2.js';
import icon_regular_check_1 from '@autosync/atx-activix-icons/regular/check-1.js';
import icon_regular_check_2 from '@autosync/atx-activix-icons/regular/check-2.js';
import icon_regular_check_circle_1 from '@autosync/atx-activix-icons/regular/check-circle-1.js';
import icon_regular_check_double from '@autosync/atx-activix-icons/regular/check-double.js';
import icon_regular_check_payment_sign from '@autosync/atx-activix-icons/regular/check-payment-sign.js';
import icon_regular_check_shield from '@autosync/atx-activix-icons/regular/check-shield.js';
import icon_regular_check_square from '@autosync/atx-activix-icons/regular/check-square.js';
import icon_regular_checklist from '@autosync/atx-activix-icons/regular/checklist.js';
import icon_regular_cloud_upload from '@autosync/atx-activix-icons/regular/cloud-upload.js';
import icon_regular_coffee_cup from '@autosync/atx-activix-icons/regular/coffee-cup.js';
import icon_regular_cog_browser from '@autosync/atx-activix-icons/regular/cog-browser.js';
import icon_regular_cog from '@autosync/atx-activix-icons/regular/cog.js';
import icon_regular_color_brush_3 from '@autosync/atx-activix-icons/regular/color-brush-3.js';
import icon_regular_color_bucket_1 from '@autosync/atx-activix-icons/regular/color-bucket-1.js';
import icon_regular_color_palette from '@autosync/atx-activix-icons/regular/color-palette.js';
import icon_regular_common_file_double_1 from '@autosync/atx-activix-icons/regular/common-file-double-1.js';
import icon_regular_common_file_download from '@autosync/atx-activix-icons/regular/common-file-download.js';
import icon_regular_common_file_empty from '@autosync/atx-activix-icons/regular/common-file-empty.js';
import icon_regular_common_file_horizontal_image from '@autosync/atx-activix-icons/regular/common-file-horizontal-image.js';
import icon_regular_common_file_text from '@autosync/atx-activix-icons/regular/common-file-text.js';
import icon_regular_composition_window_man from '@autosync/atx-activix-icons/regular/composition-window-man.js';
import icon_regular_content_paper_edit from '@autosync/atx-activix-icons/regular/content-paper-edit.js';
import icon_regular_content_pencil_write from '@autosync/atx-activix-icons/regular/content-pencil-write.js';
import icon_regular_copy_paste from '@autosync/atx-activix-icons/regular/copy-paste.js';
import icon_regular_copy_paste_1 from '@autosync/atx-activix-icons/regular/copy-paste-1.js';
import icon_regular_credit_card_1 from '@autosync/atx-activix-icons/regular/credit-card-1.js';
import icon_regular_cursor from '@autosync/atx-activix-icons/regular/cursor.js';
import icon_regular_data_transfer_diagonal from '@autosync/atx-activix-icons/regular/data-transfer-diagonal.js';
import icon_regular_data_transfer_three_back_forth_back from '@autosync/atx-activix-icons/regular/data-transfer-three-back-forth-back.js';
import icon_regular_data_transfer_vertical from '@autosync/atx-activix-icons/regular/data-transfer-vertical.js';
import icon_regular_database_upload from '@autosync/atx-activix-icons/regular/database-upload.js';
import icon_regular_delete_1 from '@autosync/atx-activix-icons/regular/delete-1.js';
import icon_regular_delete from '@autosync/atx-activix-icons/regular/delete.js';
import icon_regular_design_tool_magic_wand from '@autosync/atx-activix-icons/regular/design-tool-magic-wand.js';
import icon_regular_diagram_fall_down from '@autosync/atx-activix-icons/regular/diagram-fall-down.js';
import icon_regular_direction_button_arrows from '@autosync/atx-activix-icons/regular/direction-button-arrows.js';
import icon_regular_dislike_1 from '@autosync/atx-activix-icons/regular/dislike-1.js';
import icon_regular_download_button from '@autosync/atx-activix-icons/regular/download-button.js';
import icon_regular_drawer_send from '@autosync/atx-activix-icons/regular/drawer-send.js';
import icon_regular_drawer_play from '@autosync/atx-activix-icons/regular/drawer-play.js';
import icon_regular_eraser from '@autosync/atx-activix-icons/regular/eraser.js';
import icon_regular_earth_1 from '@autosync/atx-activix-icons/regular/earth-1.js';
import icon_regular_email_action_check from '@autosync/atx-activix-icons/regular/email-action-check.js';
import icon_regular_email_action_read from '@autosync/atx-activix-icons/regular/email-action-read.js';
import icon_regular_email_action_reply from '@autosync/atx-activix-icons/regular/email-action-reply.js';
import icon_regular_email_action_unread from '@autosync/atx-activix-icons/regular/email-action-unread.js';
import icon_regular_email_action_disable from '@autosync/atx-activix-icons/regular/email-action-disable.js';
import icon_regular_expand_2 from '@autosync/atx-activix-icons/regular/expand-2.js';
import icon_regular_expand_3 from '@autosync/atx-activix-icons/regular/expand-3.js';
import icon_regular_expand_6 from '@autosync/atx-activix-icons/regular/expand-6.js';
import icon_regular_expand_horizontal_2 from '@autosync/atx-activix-icons/regular/expand-horizontal-2.js';
import icon_regular_filter_1 from '@autosync/atx-activix-icons/regular/filter-1.js';
import icon_regular_flag_plain_3 from '@autosync/atx-activix-icons/regular/flag-plain-3.js';
import icon_regular_floppy_disk_1 from '@autosync/atx-activix-icons/regular/floppy-disk-1.js';
import icon_regular_following_1 from '@autosync/atx-activix-icons/regular/following-1.js';
import icon_regular_folder_empty from '@autosync/atx-activix-icons/regular/folder-empty.js';
import icon_regular_font_expand_vertical from '@autosync/atx-activix-icons/regular/font-expand-vertical.js';
import icon_regular_gas_load from '@autosync/atx-activix-icons/regular/gas-load.js';
import icon_regular_gift_box from '@autosync/atx-activix-icons/regular/gift-box.js';
import icon_regular_graph_stats from '@autosync/atx-activix-icons/regular/graph-stats.js';
import icon_regular_hand_expand from '@autosync/atx-activix-icons/regular/hand-expand.js';
import icon_regular_headphones_customer_support from '@autosync/atx-activix-icons/regular/headphones-customer-support.js';
import icon_regular_hierarchy_4 from '@autosync/atx-activix-icons/regular/hierarchy-4.js';
import icon_regular_house_chimney_2 from '@autosync/atx-activix-icons/regular/house-chimney-2.js';
import icon_regular_house_garage from '@autosync/atx-activix-icons/regular/house-garage.js';
import icon_regular_human_resources_employee_previous from '@autosync/atx-activix-icons/regular/human-resources-employee-previous.js';
import icon_regular_hyperlink from '@autosync/atx-activix-icons/regular/hyperlink.js';
import icon_regular_hyperlink_circle_horizontal from '@autosync/atx-activix-icons/regular/hyperlink-circle-horizontal.js';
import icon_regular_image_file_landscape from '@autosync/atx-activix-icons/regular/image-file-landscape.js';
import icon_regular_image_file_camera from '@autosync/atx-activix-icons/regular/image-file-camera.js';
import icon_regular_image_file_jpg from '@autosync/atx-activix-icons/regular/image-file-jpg.js';
import icon_regular_image_file_svg from '@autosync/atx-activix-icons/regular/image-file-svg.js';
import icon_regular_image_file_png from '@autosync/atx-activix-icons/regular/image-file-png.js';
import icon_regular_indent_left from '@autosync/atx-activix-icons/regular/indent-left.js';
import icon_regular_information_circle from '@autosync/atx-activix-icons/regular/information-circle.js';
import icon_regular_keyboard_arrow_top_right from '@autosync/atx-activix-icons/regular/keyboard-arrow-top-right.js';
import icon_regular_lab_flask_experiment from '@autosync/atx-activix-icons/regular/lab-flask-experiment.js';
import icon_regular_layers_front from '@autosync/atx-activix-icons/regular/layers-front.js';
import icon_regular_layout_two_colums from '@autosync/atx-activix-icons/regular/layout-two-colums.js';
import icon_regular_like_1 from '@autosync/atx-activix-icons/regular/like-1.js';
import icon_regular_list_bullets from '@autosync/atx-activix-icons/regular/list-bullets.js';
import icon_regular_list_numbers from '@autosync/atx-activix-icons/regular/list-numbers.js';
import icon_regular_lock_1 from '@autosync/atx-activix-icons/regular/lock-1.js';
import icon_regular_lock_unlock from '@autosync/atx-activix-icons/regular/lock-unlock.js';
import icon_regular_login_1 from '@autosync/atx-activix-icons/regular/login-1.js';
import icon_regular_login_key from '@autosync/atx-activix-icons/regular/login-key.js';
import icon_regular_login_keys from '@autosync/atx-activix-icons/regular/login-keys.js';
import icon_regular_logout_1 from '@autosync/atx-activix-icons/regular/logout-1.js';
import icon_regular_mailbox_in from '@autosync/atx-activix-icons/regular/mailbox-in.js';
import icon_regular_matches_fire from '@autosync/atx-activix-icons/regular/matches-fire.js';
import icon_regular_meeting_camera from '@autosync/atx-activix-icons/regular/meeting-camera.js';
import icon_regular_megaphone_1 from '@autosync/atx-activix-icons/regular/megaphone-1.js';
import icon_regular_messages_bubble from '@autosync/atx-activix-icons/regular/messages-bubble.js';
import icon_regular_messages_bubble_square_information from '@autosync/atx-activix-icons/regular/messages-bubble-square-information.js';
import icon_regular_messages_bubble_square_typing from '@autosync/atx-activix-icons/regular/messages-bubble-square-typing.js';
import icon_regular_messages_bubble_typing_1 from '@autosync/atx-activix-icons/regular/messages-bubble-typing-1.js';
import icon_regular_mobile_phone from '@autosync/atx-activix-icons/regular/mobile-phone.js';
import icon_regular_modern_tv_flat_screen from '@autosync/atx-activix-icons/regular/modern-tv-flat-screen.js';
import icon_regular_money_bag_dollar from '@autosync/atx-activix-icons/regular/money-bag-dollar.js';
import icon_regular_monitor_play from '@autosync/atx-activix-icons/regular/monitor-play.js';
import icon_regular_microphone from '@autosync/atx-activix-icons/regular/microphone.js';
import icon_regular_move_left from '@autosync/atx-activix-icons/regular/move-left.js';
import icon_regular_move_right from '@autosync/atx-activix-icons/regular/move-right.js';
import icon_regular_multiple_neutral_2 from '@autosync/atx-activix-icons/regular/multiple-neutral-2.js';
import icon_regular_navigation_arrows_left_1 from '@autosync/atx-activix-icons/regular/navigation-arrows-left-1.js';
import icon_regular_navigation_arrows_right_1 from '@autosync/atx-activix-icons/regular/navigation-arrows-right-1.js';
import icon_regular_navigation_left_circle_1 from '@autosync/atx-activix-icons/regular/navigation-left-circle-1.js';
import icon_regular_navigation_left from '@autosync/atx-activix-icons/regular/navigation-left.js';
import icon_regular_navigation_menu from '@autosync/atx-activix-icons/regular/navigation-menu.js';
import icon_regular_navigation_menu_horizontal from '@autosync/atx-activix-icons/regular/navigation-menu-horizontal.js';
import icon_regular_navigation_menu_vertical from '@autosync/atx-activix-icons/regular/navigation-menu-vertical.js';
import icon_regular_navigation_right_circle_1 from '@autosync/atx-activix-icons/regular/navigation-right-circle_1.js';
import icon_regular_network_clock from '@autosync/atx-activix-icons/regular/network-clock.js';
import icon_regular_newspaper from '@autosync/atx-activix-icons/regular/newspaper.js';
import icon_regular_night_moon_new from '@autosync/atx-activix-icons/regular/night-moon-new.js';
import icon_regular_notes_paper_text from '@autosync/atx-activix-icons/regular/notes-paper-text.js';
import icon_regular_notes_book_text from '@autosync/atx-activix-icons/regular/notes-book-text.js';
import icon_regular_office_file_doc from '@autosync/atx-activix-icons/regular/office-file-doc.js';
import icon_regular_office_file_pdf from '@autosync/atx-activix-icons/regular/office-file-pdf.js';
import icon_regular_office_file_presentation_1 from '@autosync/atx-activix-icons/regular/office-file-presentation-1.js';
import icon_regular_office_file_xls from '@autosync/atx-activix-icons/regular/office-file-xls.js';
import icon_regular_open_external_link from '@autosync/atx-activix-icons/regular/open-external-link.js';
import icon_regular_paragraph_left_align from '@autosync/atx-activix-icons/regular/paragraph-left-align.js';
import icon_regular_paragraph_right_align from '@autosync/atx-activix-icons/regular/paragraph-right-align.js';
import icon_regular_paragraph_center_align from '@autosync/atx-activix-icons/regular/paragraph-center-align.js';
import icon_regular_paragraph_justified_align from '@autosync/atx-activix-icons/regular/paragraph-justified-align.js';
import icon_regular_password_desktop_approved from '@autosync/atx-activix-icons/regular/password-desktop-approved.js';
import icon_regular_pencil_1 from '@autosync/atx-activix-icons/regular/pencil-1.js';
import icon_regular_pencil_write from '@autosync/atx-activix-icons/regular/pencil-write.js';
import icon_regular_phone_actions_call from '@autosync/atx-activix-icons/regular/phone-actions-call.js';
import icon_regular_pencil_circle from '@autosync/atx-activix-icons/regular/pencil-circle.js';
import icon_regular_performance_increase_mail from '@autosync/atx-activix-icons/regular/performance-increase-mail.js';
import icon_regular_phone_actions_next from '@autosync/atx-activix-icons/regular/phone-actions-next.js';
import icon_regular_phone_landline from '@autosync/atx-activix-icons/regular/phone-landline.js';
import icon_regular_phone_retro_1 from '@autosync/atx-activix-icons/regular/phone-retro-1.js';
import icon_regular_phone from '@autosync/atx-activix-icons/regular/phone.js';
import icon_regular_pin_1 from '@autosync/atx-activix-icons/regular/pin-1.js';
import icon_regular_police_man_1 from '@autosync/atx-activix-icons/regular/police-man-1.js';
import icon_regular_printer from '@autosync/atx-activix-icons/regular/printer.js';
import icon_regular_question_circle from '@autosync/atx-activix-icons/regular/question-circle.js';
import icon_regular_rating_star from '@autosync/atx-activix-icons/regular/rating-star.js';
import icon_regular_redo from '@autosync/atx-activix-icons/regular/redo.js';
import icon_regular_real_estate_sign_board_sold from '@autosync/atx-activix-icons/regular/real-estate-sign-board-sold.js';
import icon_regular_remove_circle from '@autosync/atx-activix-icons/regular/remove-circle.js';
import icon_regular_remove_shield from '@autosync/atx-activix-icons/regular/remove-shield.js';
import icon_regular_remove from '@autosync/atx-activix-icons/regular/remove.js';
import icon_regular_reorder_down from '@autosync/atx-activix-icons/regular/reorder-down.js';
import icon_regular_reorder_up from '@autosync/atx-activix-icons/regular/reorder-up.js';
import icon_regular_road_straight from '@autosync/atx-activix-icons/regular/road-straight.js';
import icon_regular_road_woods from '@autosync/atx-activix-icons/regular/road-woods.js';
import icon_regular_saving_bank from '@autosync/atx-activix-icons/regular/saving-bank.js';
import icon_regular_screen_1 from '@autosync/atx-activix-icons/regular/screen-1.js';
import icon_regular_search_remove from '@autosync/atx-activix-icons/regular/search-remove.js';
import icon_regular_search from '@autosync/atx-activix-icons/regular/search.js';
import icon_regular_send_email_monitor from '@autosync/atx-activix-icons/regular/send-email-monitor.js';
import icon_regular_send_email from '@autosync/atx-activix-icons/regular/send-email.js';
import icon_regular_shield_settings from '@autosync/atx-activix-icons/regular/shield-settings.js';
import icon_regular_shop from '@autosync/atx-activix-icons/regular/shop.js';
import icon_regular_shop_sign_open from '@autosync/atx-activix-icons/regular/shop-sign-open.js';
import icon_regular_shopping_cart_check from '@autosync/atx-activix-icons/regular/shopping-cart-check.js';
import icon_regular_sign_badge_circle from '@autosync/atx-activix-icons/regular/sign-badge-circle.js';
import icon_regular_single_man_actions from '@autosync/atx-activix-icons/regular/single-man-actions.js';
import icon_regular_single_neutral_actions_alarm from '@autosync/atx-activix-icons/regular/single-neutral-actions-alarm.js';
import icon_regular_single_neutral_actions_block from '@autosync/atx-activix-icons/regular/single-neutral-actions-block.js';
import icon_regular_single_neutral_actions_warning from '@autosync/atx-activix-icons/regular/single-neutral-actions-warning.js';
import icon_regular_single_neutral_actions_check_2 from '@autosync/atx-activix-icons/regular/single-neutral-actions-check-2.js';
import icon_regular_single_neutral_actions_question from '@autosync/atx-activix-icons/regular/single-neutral-actions-question.js';
import icon_regular_single_neutral_actions_remove from '@autosync/atx-activix-icons/regular/single-neutral-actions-remove.js';
import icon_regular_single_neutral_actions from '@autosync/atx-activix-icons/regular/single-neutral-actions.js';
import icon_regular_single_neutral from '@autosync/atx-activix-icons/regular/single-neutral.js';
import icon_regular_single_neutral_circle from '@autosync/atx-activix-icons/regular/single-neutral-circle.js';
import icon_regular_single_neutral_id_card_3 from '@autosync/atx-activix-icons/regular/single-neutral-id-card-3.js';
import icon_regular_share_1 from '@autosync/atx-activix-icons/regular/share-1.js';
import icon_regular_signal_loading from '@autosync/atx-activix-icons/regular/signal-loading.js';
import icon_regular_smiley_bad from '@autosync/atx-activix-icons/regular/smiley-bad.js';
import icon_regular_smiley_smile_2 from '@autosync/atx-activix-icons/regular/smiley-smile-2.js';
import icon_regular_social_media_facebook_1 from '@autosync/atx-activix-icons/regular/social-media-facebook-1.js';
import icon_regular_stopwatch from '@autosync/atx-activix-icons/regular/stopwatch.js';
import icon_regular_superscript from '@autosync/atx-activix-icons/regular/superscript.js';
import icon_regular_subscript from '@autosync/atx-activix-icons/regular/subscript.js';
import icon_regular_switch_off_1 from '@autosync/atx-activix-icons/regular/switch-off-1.js';
import icon_regular_synchronize_arrows_square_1 from '@autosync/atx-activix-icons/regular/synchronize-arrows-square-1.js';
import icon_regular_synchronize_arrows_warning from '@autosync/atx-activix-icons/regular/synchronize-arrows-warning.js';
import icon_regular_target_center_1 from '@autosync/atx-activix-icons/regular/target-center-1.js';
import icon_regular_task_list_approve from '@autosync/atx-activix-icons/regular/task-list-approve.js';
import icon_regular_task_list_check from '@autosync/atx-activix-icons/regular/task-list-check.js';
import icon_regular_task_list_warning from '@autosync/atx-activix-icons/regular/task-list-warning.js';
import icon_regular_text_style from '@autosync/atx-activix-icons/regular/text-style.js';
import icon_regular_text_bold from '@autosync/atx-activix-icons/regular/text-bold.js';
import icon_regular_text_input_area from '@autosync/atx-activix-icons/regular/text-input-area.js';
import icon_regular_text_italic from '@autosync/atx-activix-icons/regular/text-italic.js';
import icon_regular_text_underline from '@autosync/atx-activix-icons/regular/text-underline.js';
import icon_regular_text_strike_through from '@autosync/atx-activix-icons/regular/text-strike-through.js';
import icon_regular_team_meeting from '@autosync/atx-activix-icons/regular/team-meeting.js';
import icon_regular_time_clock_circle from '@autosync/atx-activix-icons/regular/time-clock-circle.js';
import icon_regular_tools_wench from '@autosync/atx-activix-icons/regular/tools-wench.js';
import icon_regular_transportation_ticket_car_transfer_1 from '@autosync/atx-activix-icons/regular/transportation-ticket-car-transfer-1.js';
import icon_regular_trash_1 from '@autosync/atx-activix-icons/regular/trash-1.js';
import icon_regular_undo from '@autosync/atx-activix-icons/regular/undo.js';
import icon_regular_upload_thick_bottom from '@autosync/atx-activix-icons/regular/upload-thick-bottom.js';
import icon_regular_video_file_camera from '@autosync/atx-activix-icons/regular/video-file-camera.js';
import icon_regular_video_file_play from '@autosync/atx-activix-icons/regular/video-file-play.js';
import icon_regular_video_game_magic_wand from '@autosync/atx-activix-icons/regular/video-game-magic-wand.js';
import icon_regular_view_1 from '@autosync/atx-activix-icons/regular/view-1.js';
import icon_regular_view_off from '@autosync/atx-activix-icons/regular/view-off.js';
import icon_regular_vip_crown_queen_2 from '@autosync/atx-activix-icons/regular/vip-crown-queen-2.js';
import icon_regular_walking from '@autosync/atx-activix-icons/regular/walking.js';
import icon_regular_wench_1 from '@autosync/atx-activix-icons/regular/wench-1.js';
import icon_regular_wifi_signal_2 from '@autosync/atx-activix-icons/regular/wifi-signal-2.js';
import icon_regular_check_double_1 from '@autosync/atx-activix-icons/regular/check-double-1.js';
import icon_regular_font_size from '@autosync/atx-activix-icons/regular/font-size.js';
import icon_regular_color_painting_palette from '@autosync/atx-activix-icons/regular/color-painting-palette.js';
import icon_regular_wifi_signal_4 from '@autosync/atx-activix-icons/regular/wifi-signal-4.js';
import icon_regular_maps from '@autosync/atx-activix-icons/regular/maps.js';
import icon_regular_single_neutral_profile_picture from '@autosync/atx-activix-icons/regular/single-neutral-profile-picture.js';
import icon_regular_official_building_3 from '@autosync/atx-activix-icons/regular/official-building-3.js';

const icon_regular_ai_edit_spark = {
    name: 'ai-edit-spark',
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path d="M2.83667 1.60596V4.10596" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.58667 2.85596H4.08667" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.57518 4.07808L12.6877 7.19062M6.55531 13.2245L2.43091 14.3034L3.50685 10.1676L10.535 3.11554C11.3719 2.27638 12.7467 2.21644 13.6433 3.11554C14.4802 3.95469 14.4802 5.33328 13.6433 6.23236L6.55531 13.2245Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3824 12.3594V14.8594" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.1324 13.6094H14.6324" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>',
};

const icon_regular_sparkles = {
    name: 'sparkles',
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path d="M8.89099 5.79117C8.97283 6.10841 9.13882 6.39838 9.37048 6.63004C9.60207 6.86154 9.89131 7.02674 10.2084 7.10856L13.6654 7.99918L10.2084 8.89078C9.89119 8.97261 9.60213 9.13867 9.37048 9.37028C9.13887 9.60189 8.97285 9.89101 8.89099 10.2082L7.99841 13.6652L7.10876 10.2082C7.02693 9.89116 6.86171 9.60183 6.63025 9.37028C6.39859 9.13862 6.10861 8.97262 5.79138 8.89078L2.33533 7.99918L5.79138 7.10856C6.10833 7.02684 6.39768 6.86133 6.62927 6.63004C6.86085 6.39862 7.02676 6.1091 7.10876 5.79215V5.79117L7.99939 2.33317L8.89099 5.79117Z" stroke="currentColor" stroke-linecap="round"/><path d="M13.3333 2V4.66667" stroke="currentColor" stroke-linecap="round"/><path d="M14.6667 3.33333H12" stroke="currentColor" stroke-linecap="round"/><path d="M2.66667 11.3333V12.6667" stroke="currentColor" stroke-linecap="round"/><path d="M3.33333 12H2" stroke="currentColor" stroke-linecap="round"/>',
};

const icon_regular_ai_stop = {
    name: 'ai-stop',
    width: 16,
    height: 16,
    viewBox: '0 0 12 12',
    data: '<path d="M0.610547 6C0.610547 7.42937 1.17836 8.8002 2.18908 9.81092C3.1998 10.8216 4.57063 11.3895 6 11.3895C7.42937 11.3895 8.8002 10.8216 9.81092 9.81092C10.8216 8.8002 11.3895 7.42937 11.3895 6C11.3895 4.57063 10.8216 3.1998 9.81092 2.18908C8.8002 1.17836 7.42937 0.610547 6 0.610547C4.57063 0.610547 3.1998 1.17836 2.18908 2.18908C1.17836 3.1998 0.610547 4.57063 0.610547 6Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><rect x="4" y="4" width="4" height="4" rx="0.75" fill="currentColor"/>',
};

const icon_regular_ai_feedback_thumbs_up = {
    name: 'ai-feedback-thumbs-up',
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path d="M4.08333 5.8333V12.8333" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 3.43L8.16667 5.8333H11.5675C11.7486 5.8333 11.9273 5.8755 12.0892 5.9565C12.2512 6.0375 12.3922 6.1551 12.5008 6.3C12.6095 6.4449 12.6829 6.6131 12.7153 6.7913C12.7477 6.9695 12.7382 7.1528 12.6875 7.3267L11.3283 11.9933C11.2577 12.2357 11.1103 12.4485 10.9083 12.6C10.7064 12.7515 10.4608 12.8333 10.2083 12.8333H2.33333C2.02391 12.8333 1.72717 12.7104 1.50838 12.4916C1.28958 12.2728 1.16667 11.9761 1.16667 11.6667V7C1.16667 6.6906 1.28958 6.3938 1.50838 6.175C1.72717 5.9563 2.02391 5.8333 2.33333 5.8333H3.94333C4.16038 5.8332 4.3731 5.7726 4.55756 5.6582C4.74202 5.5438 4.89091 5.3802 4.9875 5.1858L7 1.16667C7.27509 1.17007 7.54585 1.2356 7.79205 1.35835C8.03826 1.4811 8.25354 1.6579 8.42182 1.87553C8.5901 2.09317 8.70702 2.34603 8.76385 2.6152C8.82067 2.88438 8.81594 3.16291 8.75 3.43Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>',
};

const icon_regular_ai_feedback_thumbs_down = {
    name: 'ai-feedback-thumbs-down',
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path d="M9.9167 8.1667V1.16667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.25 10.57L5.8333 8.1667H2.4325C2.2514 8.1667 2.0727 8.1245 1.9107 8.0435C1.7488 7.9625 1.6078 7.8449 1.4992 7.7C1.3905 7.5551 1.317 7.3869 1.2846 7.2087C1.2522 7.0305 1.2618 6.8472 1.3125 6.6733L2.6717 2.00667C2.7423 1.76433 2.8897 1.55146 3.0917 1.4C3.2936 1.24854 3.5392 1.16667 3.7917 1.16667H11.6667C11.9761 1.16667 12.2728 1.28958 12.4916 1.50838C12.7104 1.72717 12.8333 2.02391 12.8333 2.33333V7C12.8333 7.3094 12.7104 7.6062 12.4916 7.825C12.2728 8.0438 11.9761 8.1667 11.6667 8.1667H10.0567C9.8396 8.1668 9.6269 8.2274 9.4424 8.3418C9.258 8.4562 9.1091 8.6198 9.0125 8.8142L7 12.8333C6.7249 12.8299 6.4541 12.7644 6.2079 12.6417C5.9617 12.5189 5.7465 12.3421 5.5782 12.1245C5.4099 11.9068 5.293 11.654 5.2362 11.3848C5.1793 11.1156 5.1841 10.8371 5.25 10.57Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>',
};

export const iconsMap = {
    'bold/add': icon_bold_add,
    'bold/alert-circle': icon_bold_alert_circle,
    'bold/alert-triangle': icon_bold_alert_triangle,
    'bold/align-left': icon_bold_align_left,
    'bold/analytics-bars-horizontal': icon_bold_analytics_bars_horizontal,
    'bold/arrow-button-right-2': icon_bold_arrow_button_right_2,
    'bold/arrow-double-right-1': icon_bold_arrow_double_right_1,
    'bold/arrow-down': icon_bold_arrow_down,
    'bold/arrow-down-1': icon_bold_arrow_down_1,
    'bold/arrow-up': icon_bold_arrow_up,
    'bold/arrow-up-1': icon_bold_arrow_up_1,
    'bold/arrow-thick-circle-down-1': icon_bold_arrow_thick_circle_down_1,
    'bold/arrow-thick-circle-up-1': icon_bold_arrow_thick_circle_up_1,
    'bold/arrow-thick-left': icon_bold_arrow_thick_left,
    'bold/arrow-thick-right': icon_bold_arrow_thick_right,
    'bold/arrow-thick-circle-bottom-left-corner': icon_bold_arrow_thick_circle_bottom_left_corner,
    'bold/arrow-thick-circle-bottom-right-corner': icon_bold_arrow_thick_circle_bottom_right_corner,
    'bold/autotrader-badge': icon_bold_autotrader_badge,
    'bold/button-stop-1': icon_bold_button_stop_1,
    'bold/car-retro-1': icon_bold_car_retro_1,
    'bold/check-1': icon_bold_check_1,
    'bold/check-2': icon_bold_check_2,
    'bold/check-circle-1': icon_bold_check_circle_1,
    'bold/check-double-1': icon_bold_check_double_1,
    'bold/close': icon_bold_close,
    'bold/controls-pause': icon_bold_controls_pause,
    'bold/arrow-button-circle-right': icon_bold_arrow_button_circle_right,
    'bold/currency-dollar': icon_bold_currency_dollar,
    'bold/delete-2': icon_bold_delete_2,
    'bold/dial-finger': icon_bold_dial_finger,
    'bold/dislike-1': icon_bold_dislike_1,
    'bold/email-action-reply': icon_bold_email_action_reply,
    'bold/email-action-unread': icon_bold_email_action_unread,
    'bold/filter-2': icon_bold_filter_2,
    'bold/layout-module': icon_bold_layout_module,
    'bold/like-1': icon_bold_like_1,
    'bold/megaphone-1': icon_bold_megaphone_1,
    'bold/messages-bubble-typing-1': icon_bold_messages_bubble_typing_1,
    'bold/microphone': icon_bold_microphone,
    'bold/multiple-neutral-2': icon_bold_multiple_neutral_2,
    'bold/navigation-menu-horizontal': icon_bold_navigation_menu_horizontal,
    'bold/navigation-menu-horizontal-1': icon_bold_navigation_menu_horizontal_1,
    'bold/navigation-menu-horizontal-2': icon_bold_navigation_menu_horizontal_2,
    'bold/navigation-menu-vertical': icon_bold_navigation_menu_vertical,
    'bold/phone': icon_bold_phone,
    'bold/pencil-circle': icon_bold_pencil_circle,
    'bold/pin': icon_bold_pin,
    'bold/question-circle': icon_bold_question_circle,
    'bold/rating-star': icon_bold_rating_star,
    'bold/rating-star-1': icon_bold_rating_star_1,
    'bold/remove-circle': icon_bold_remove_circle,
    'bold/remove': icon_bold_remove,
    'bold/remove-square': icon_bold_remove_square,
    'bold/scooter-sport': icon_bold_scooter_sport,
    'bold/sign-badge-circle': icon_bold_sign_badge_circle,
    'bold/single-man': icon_bold_single_man,
    'bold/social-media-facebook-1': icon_bold_social_media_facebook_1,
    'bold/subtract-circle': icon_bold_subtract_circle,
    'bold/subtract-circle-bold': icon_bold_subtract_circle_bold,
    'bold/subtract': icon_bold_subtract,
    'bold/synchronize-arrow-1': icon_bold_synchronize_arrow_1,
    'bold/synchronize-arrows-triangle': icon_bold_synchronize_arrows_triangle,
    'bold/time-clock-file-sync': icon_bold_time_clock_file_sync,
    'bold/tools-wench-screwdriver': icon_bold_tools_wench_screwdriver,
    'bold/view-1': icon_bold_view_1,
    'bold/view-off': icon_bold_view_off,
    'bold/information-desk-customer': icon_bold_information_desk_customer,
    'light/award-ribbon-star-3': icon_light_award_ribbon_star_3,
    'light/barcode-scan': icon_light_barcode_scan,
    'light/car-retro-1': icon_light_car_retro_1,
    'light/email-action-unread': icon_light_email_action_unread,
    'light/send-email-monitor': icon_light_send_email_monitor,
    'light/gauge-dashboard': icon_light_gauge_dashboard,
    'light/performance-increase-mail': icon_light_performance_increase_mail,
    'light/pin': icon_light_pin,
    'light/scooter-sport': icon_light_scooter_sport,
    'light/trophy': icon_light_trophy,
    'regular/accessories-tie': icon_regular_accessories_tie,
    'regular/analytics-graph-bar': icon_regular_analytics_graph_bar,
    'regular/accounting-bill-stack-1': icon_regular_accounting_bill_stack_1,
    'regular/accounting-calculator': icon_regular_accounting_calculator,
    'regular/accounting-document': icon_regular_accounting_document,
    'regular/accounting-invoice': icon_regular_accounting_invoice,
    'regular/add': icon_regular_add,
    'regular/alarm-bell': icon_regular_alarm_bell,
    'regular/alarm-bell-ring': icon_regular_alarm_bell_ring,
    'regular/alarm-bell-sleep': icon_regular_alarm_bell_sleep,
    'regular/alert-circle': icon_regular_alert_circle,
    'regular/alert-diamond': icon_regular_alert_diamond,
    'regular/alert-triangle': icon_regular_alert_triangle,
    'regular/align-left': icon_regular_align_left,
    'regular/angle-brackets': icon_regular_angle_brackets,
    'regular/answer-machine-paper': icon_regular_answer_machine_paper,
    'regular/archive-folder': icon_regular_archive_folder,
    'regular/arrow-button-left-1': icon_regular_arrow_button_left_1,
    'regular/arrow-button-right-1': icon_regular_arrow_button_right_1,
    'regular/arrow-circle-left': icon_regular_arrow_circle_left,
    'regular/arrow-circle-right': icon_regular_arrow_circle_right,
    'regular/arrow-corner-right': icon_regular_arrow_corner_right,
    'regular/arrow-double-right': icon_regular_arrow_double_right,
    'regular/arrow-down': icon_regular_arrow_down,
    'regular/arrow-down-1': icon_regular_arrow_down_1,
    'regular/arrow-left-1': icon_regular_arrow_left_1,
    'regular/arrow-right-1': icon_regular_arrow_right_1,
    'regular/arrow-right': icon_regular_arrow_right,
    'regular/arrow-thick-up': icon_regular_arrow_thick_up,
    'regular/arrow-up': icon_regular_arrow_up,
    'regular/arrow-up-1': icon_regular_arrow_up_1,
    'regular/attachment': icon_regular_attachment,
    'regular/ai-edit-spark': icon_regular_ai_edit_spark,
    'regular/ai-feedback-thumbs-down': icon_regular_ai_feedback_thumbs_down,
    'regular/ai-feedback-thumbs-up': icon_regular_ai_feedback_thumbs_up,
    'regular/ai-stop': icon_regular_ai_stop,
    'regular/sparkles': icon_regular_sparkles,
    'regular/audio-file': icon_regular_audio_file,
    'regular/award-ribbon-star-3': icon_regular_award_ribbon_star_3,
    'regular/award-trophy-star-1': icon_regular_award_trophy_star_1,
    'regular/baggage': icon_regular_baggage,
    'regular/bin-paper': icon_regular_bin_paper,
    'regular/book-open-2': icon_regular_book_open_2,
    'regular/bookmarks': icon_regular_bookmarks,
    'regular/briefcase': icon_regular_briefcase,
    'regular/business-deal-handshake': icon_regular_business_deal_handshake,
    'regular/button-refresh-arrows': icon_regular_button_refresh_arrows,
    'regular/button-refresh-one': icon_regular_button_refresh_one,
    'regular/button-shuffle': icon_regular_button_shuffle,
    'regular/calendar-3': icon_regular_calendar_3,
    'regular/calendar-add': icon_regular_calendar_add,
    'regular/calendar-check': icon_regular_calendar_check,
    'regular/calendar-clock': icon_regular_calendar_clock,
    'regular/calendar-favorite-heart': icon_regular_calendar_favorite_heart,
    'regular/calendar-favorite': icon_regular_calendar_favorite,
    'regular/calendar-search': icon_regular_calendar_search,
    'regular/calendar-setting': icon_regular_calendar_setting,
    'regular/calendar-sync': icon_regular_calendar_sync,
    'regular/calendar': icon_regular_calendar,
    'regular/car-1': icon_regular_car_1,
    'regular/car-actions-disable-1': icon_regular_car_actions_disable_1,
    'regular/car-actions-search-1': icon_regular_car_actions_search_1,
    'regular/car-actions-shield': icon_regular_car_actions_shield,
    'regular/car-parking-home': icon_regular_car_parking_home,
    'regular/car-repair-fluid': icon_regular_car_repair_fluid,
    'regular/car-retro-2': icon_regular_car_retro_2,
    'regular/cash-briefcase': icon_regular_cash_briefcase,
    'regular/cash-payment-bag': icon_regular_cash_payment_bag,
    'regular/cash-payment-sign-2': icon_regular_cash_payment_sign_2,
    'regular/check-1': icon_regular_check_1,
    'regular/check-2': icon_regular_check_2,
    'regular/check-circle-1': icon_regular_check_circle_1,
    'regular/check-double': icon_regular_check_double,
    'regular/check-payment-sign': icon_regular_check_payment_sign,
    'regular/check-shield': icon_regular_check_shield,
    'regular/check-square': icon_regular_check_square,
    'regular/checklist': icon_regular_checklist,
    'regular/cloud-upload': icon_regular_cloud_upload,
    'regular/coffee-cup': icon_regular_coffee_cup,
    'regular/cog-browser': icon_regular_cog_browser,
    'regular/cog': icon_regular_cog,
    'regular/color-brush-3': icon_regular_color_brush_3,
    'regular/color-bucket-1': icon_regular_color_bucket_1,
    'regular/color-palette': icon_regular_color_palette,
    'regular/common-file-double-1': icon_regular_common_file_double_1,
    'regular/common-file-download': icon_regular_common_file_download,
    'regular/common-file-empty': icon_regular_common_file_empty,
    'regular/common-file-horizontal-image': icon_regular_common_file_horizontal_image,
    'regular/common-file-text': icon_regular_common_file_text,
    'regular/composition-window-man': icon_regular_composition_window_man,
    'regular/content-paper-edit': icon_regular_content_paper_edit,
    'regular/content-pencil-write': icon_regular_content_pencil_write,
    'regular/copy-paste': icon_regular_copy_paste,
    'regular/copy-paste-1': icon_regular_copy_paste_1,
    'regular/credit-card-1': icon_regular_credit_card_1,
    'regular/cursor': icon_regular_cursor,
    'regular/data-transfer-diagonal': icon_regular_data_transfer_diagonal,
    'regular/data-transfer-three-back-forth-back': icon_regular_data_transfer_three_back_forth_back,
    'regular/data-transfer-vertical': icon_regular_data_transfer_vertical,
    'regular/database-upload': icon_regular_database_upload,
    'regular/delete-1': icon_regular_delete_1,
    'regular/delete': icon_regular_delete,
    'regular/design-tool-magic-wand': icon_regular_design_tool_magic_wand,
    'regular/diagram-fall-down': icon_regular_diagram_fall_down,
    'regular/direction-button-arrows': icon_regular_direction_button_arrows,
    'regular/dislike-1': icon_regular_dislike_1,
    'regular/download-button': icon_regular_download_button,
    'regular/drawer-send': icon_regular_drawer_send,
    'regular/drawer-play': icon_regular_drawer_play,
    'regular/eraser': icon_regular_eraser,
    'regular/earth-1': icon_regular_earth_1,
    'regular/email-action-check': icon_regular_email_action_check,
    'regular/email-action-read': icon_regular_email_action_read,
    'regular/email-action-reply': icon_regular_email_action_reply,
    'regular/email-action-unread': icon_regular_email_action_unread,
    'regular/email-action-disable': icon_regular_email_action_disable,
    'regular/expand-2': icon_regular_expand_2,
    'regular/expand-3': icon_regular_expand_3,
    'regular/expand-6': icon_regular_expand_6,
    'regular/expand-horizontal-2': icon_regular_expand_horizontal_2,
    'regular/filter-1': icon_regular_filter_1,
    'regular/flag-plain-3': icon_regular_flag_plain_3,
    'regular/floppy-disk-1': icon_regular_floppy_disk_1,
    'regular/following-1': icon_regular_following_1,
    'regular/folder-empty': icon_regular_folder_empty,
    'regular/font-expand-vertical': icon_regular_font_expand_vertical,
    'regular/gas-load': icon_regular_gas_load,
    'regular/gift-box': icon_regular_gift_box,
    'regular/graph-stats': icon_regular_graph_stats,
    'regular/hand-expand': icon_regular_hand_expand,
    'regular/headphones-customer-support': icon_regular_headphones_customer_support,
    'regular/hierarchy-4': icon_regular_hierarchy_4,
    'regular/house-chimney-2': icon_regular_house_chimney_2,
    'regular/house-garage': icon_regular_house_garage,
    'regular/human-resources-employee-previous': icon_regular_human_resources_employee_previous,
    'regular/hyperlink': icon_regular_hyperlink,
    'regular/hyperlink-circle-horizontal': icon_regular_hyperlink_circle_horizontal,
    'regular/image-file-landscape': icon_regular_image_file_landscape,
    'regular/image-file-camera': icon_regular_image_file_camera,
    'regular/image-file-jpg': icon_regular_image_file_jpg,
    'regular/image-file-svg': icon_regular_image_file_svg,
    'regular/image-file-png': icon_regular_image_file_png,
    'regular/indent-left': icon_regular_indent_left,
    'regular/information-circle': icon_regular_information_circle,
    'regular/keyboard-arrow-top-right': icon_regular_keyboard_arrow_top_right,
    'regular/lab-flask-experiment': icon_regular_lab_flask_experiment,
    'regular/layers-front': icon_regular_layers_front,
    'regular/layout-two-colums': icon_regular_layout_two_colums,
    'regular/like-1': icon_regular_like_1,
    'regular/list-bullets': icon_regular_list_bullets,
    'regular/list-numbers': icon_regular_list_numbers,
    'regular/lock-1': icon_regular_lock_1,
    'regular/lock-unlock': icon_regular_lock_unlock,
    'regular/login-1': icon_regular_login_1,
    'regular/login-key': icon_regular_login_key,
    'regular/login-keys': icon_regular_login_keys,
    'regular/logout-1': icon_regular_logout_1,
    'regular/mailbox-in': icon_regular_mailbox_in,
    'regular/matches-fire': icon_regular_matches_fire,
    'regular/meeting-camera': icon_regular_meeting_camera,
    'regular/megaphone-1': icon_regular_megaphone_1,
    'regular/messages-bubble': icon_regular_messages_bubble,
    'regular/messages-bubble-square-information': icon_regular_messages_bubble_square_information,
    'regular/messages-bubble-square-typing': icon_regular_messages_bubble_square_typing,
    'regular/messages-bubble-typing-1': icon_regular_messages_bubble_typing_1,
    'regular/mobile-phone': icon_regular_mobile_phone,
    'regular/modern-tv-flat-screen': icon_regular_modern_tv_flat_screen,
    'regular/money-bag-dollar': icon_regular_money_bag_dollar,
    'regular/monitor-play': icon_regular_monitor_play,
    'regular/microphone': icon_regular_microphone,
    'regular/move-left': icon_regular_move_left,
    'regular/move-right': icon_regular_move_right,
    'regular/multiple-neutral-2': icon_regular_multiple_neutral_2,
    'regular/navigation-arrows-left-1': icon_regular_navigation_arrows_left_1,
    'regular/navigation-arrows-right-1': icon_regular_navigation_arrows_right_1,
    'regular/navigation-left-circle-1': icon_regular_navigation_left_circle_1,
    'regular/navigation-left': icon_regular_navigation_left,
    'regular/navigation-menu': icon_regular_navigation_menu,
    'regular/navigation-menu-horizontal': icon_regular_navigation_menu_horizontal,
    'regular/navigation-menu-vertical': icon_regular_navigation_menu_vertical,
    'regular/navigation-right-circle_1': icon_regular_navigation_right_circle_1,
    'regular/network-clock': icon_regular_network_clock,
    'regular/newspaper': icon_regular_newspaper,
    'regular/night-moon-new': icon_regular_night_moon_new,
    'regular/notes-paper-text': icon_regular_notes_paper_text,
    'regular/notes-book-text': icon_regular_notes_book_text,
    'regular/office-file-doc': icon_regular_office_file_doc,
    'regular/office-file-pdf': icon_regular_office_file_pdf,
    'regular/office-file-presentation-1': icon_regular_office_file_presentation_1,
    'regular/office-file-xls': icon_regular_office_file_xls,
    'regular/open-external-link': icon_regular_open_external_link,
    'regular/paragraph-left-align': icon_regular_paragraph_left_align,
    'regular/paragraph-right-align': icon_regular_paragraph_right_align,
    'regular/paragraph-center-align': icon_regular_paragraph_center_align,
    'regular/paragraph-justified-align': icon_regular_paragraph_justified_align,
    'regular/password-desktop-approved': icon_regular_password_desktop_approved,
    'regular/pencil-1': icon_regular_pencil_1,
    'regular/pencil-write': icon_regular_pencil_write,
    'regular/phone-actions-call': icon_regular_phone_actions_call,
    'regular/pencil-circle': icon_regular_pencil_circle,
    'regular/performance-increase-mail': icon_regular_performance_increase_mail,
    'regular/phone-actions-next': icon_regular_phone_actions_next,
    'regular/phone-landline': icon_regular_phone_landline,
    'regular/phone-retro-1': icon_regular_phone_retro_1,
    'regular/phone': icon_regular_phone,
    'regular/pin-1': icon_regular_pin_1,
    'regular/police-man-1': icon_regular_police_man_1,
    'regular/printer': icon_regular_printer,
    'regular/question-circle': icon_regular_question_circle,
    'regular/rating-star': icon_regular_rating_star,
    'regular/redo': icon_regular_redo,
    'regular/real-estate-sign-board-sold': icon_regular_real_estate_sign_board_sold,
    'regular/remove-circle': icon_regular_remove_circle,
    'regular/remove-shield': icon_regular_remove_shield,
    'regular/remove': icon_regular_remove,
    'regular/reorder-down': icon_regular_reorder_down,
    'regular/reorder-up': icon_regular_reorder_up,
    'regular/road-straight': icon_regular_road_straight,
    'regular/road-woods': icon_regular_road_woods,
    'regular/saving-bank': icon_regular_saving_bank,
    'regular/screen-1': icon_regular_screen_1,
    'regular/search-remove': icon_regular_search_remove,
    'regular/search': icon_regular_search,
    'regular/send-email-monitor': icon_regular_send_email_monitor,
    'regular/send-email': icon_regular_send_email,
    'regular/shield-settings': icon_regular_shield_settings,
    'regular/shop': icon_regular_shop,
    'regular/shop-sign-open': icon_regular_shop_sign_open,
    'regular/shopping-cart-check': icon_regular_shopping_cart_check,
    'regular/sign-badge-circle': icon_regular_sign_badge_circle,
    'regular/single-man-actions': icon_regular_single_man_actions,
    'regular/single-neutral-actions-alarm': icon_regular_single_neutral_actions_alarm,
    'regular/single-neutral-actions-block': icon_regular_single_neutral_actions_block,
    'regular/single-neutral-actions-warning': icon_regular_single_neutral_actions_warning,
    'regular/single-neutral-actions-check-2': icon_regular_single_neutral_actions_check_2,
    'regular/single-neutral-actions-question': icon_regular_single_neutral_actions_question,
    'regular/single-neutral-actions-remove': icon_regular_single_neutral_actions_remove,
    'regular/single-neutral-actions': icon_regular_single_neutral_actions,
    'regular/single-neutral': icon_regular_single_neutral,
    'regular/single-neutral-circle': icon_regular_single_neutral_circle,
    'regular/single-neutral-id-card-3': icon_regular_single_neutral_id_card_3,
    'regular/share-1': icon_regular_share_1,
    'regular/signal-loading': icon_regular_signal_loading,
    'regular/smiley-bad': icon_regular_smiley_bad,
    'regular/smiley-smile-2': icon_regular_smiley_smile_2,
    'regular/social-media-facebook-1': icon_regular_social_media_facebook_1,
    'regular/stopwatch': icon_regular_stopwatch,
    'regular/superscript': icon_regular_superscript,
    'regular/subscript': icon_regular_subscript,
    'regular/switch-off-1': icon_regular_switch_off_1,
    'regular/synchronize-arrows-square-1': icon_regular_synchronize_arrows_square_1,
    'regular/synchronize-arrows-warning': icon_regular_synchronize_arrows_warning,
    'regular/target-center-1': icon_regular_target_center_1,
    'regular/task-list-approve': icon_regular_task_list_approve,
    'regular/task-list-check': icon_regular_task_list_check,
    'regular/task-list-warning': icon_regular_task_list_warning,
    'regular/text-style': icon_regular_text_style,
    'regular/text-bold': icon_regular_text_bold,
    'regular/text-input-area': icon_regular_text_input_area,
    'regular/text-italic': icon_regular_text_italic,
    'regular/text-underline': icon_regular_text_underline,
    'regular/text-strike-through': icon_regular_text_strike_through,
    'regular/team-meeting': icon_regular_team_meeting,
    'regular/time-clock-circle': icon_regular_time_clock_circle,
    'regular/tools-wench': icon_regular_tools_wench,
    'regular/transportation-ticket-car-transfer-1':
        icon_regular_transportation_ticket_car_transfer_1,
    'regular/trash-1': icon_regular_trash_1,
    'regular/undo': icon_regular_undo,
    'regular/upload-thick-bottom': icon_regular_upload_thick_bottom,
    'regular/video-file-camera': icon_regular_video_file_camera,
    'regular/video-file-play': icon_regular_video_file_play,
    'regular/video-game-magic-wand': icon_regular_video_game_magic_wand,
    'regular/view-1': icon_regular_view_1,
    'regular/view-off': icon_regular_view_off,
    'regular/vip-crown-queen-2': icon_regular_vip_crown_queen_2,
    'regular/walking': icon_regular_walking,
    'regular/wench-1': icon_regular_wench_1,
    'regular/wifi-signal-2': icon_regular_wifi_signal_2,
    'regular/check-double-1': icon_regular_check_double_1,
    'regular/font-size': icon_regular_font_size,
    'regular/color-painting-palette': icon_regular_color_painting_palette,
    'regular/wifi-signal-4': icon_regular_wifi_signal_4,
    'regular/maps': icon_regular_maps,
    'regular/single-neutral-profile-picture': icon_regular_single_neutral_profile_picture,
    'regular/official-building-3': icon_regular_official_building_3,
};

export default iconsMap;
